import { useLanguage, type Language } from "../context/LanguageContext";

export default function LanguagePicker({
  solid,
  textClassName = "text-[11px]",
}: {
  solid: boolean;
  /** Overrides the default 11px sizing — the mobile slide-out menu passes
   * text-sm here to match its other links, which are bigger than the
   * compact desktop nav this component was originally sized for. */
  textClassName?: string;
}) {
  const { language, setLanguage } = useLanguage();
  const options: Language[] = ["ru", "kz"];

  return (
    <div
      className={`flex items-center gap-1 ${textClassName} font-semibold uppercase tracking-wide ${
        solid ? "text-steel-500" : "text-white/70"
      }`}
    >
      {options.map((opt, i) => (
        <span key={opt} className="flex items-center gap-1">
          {i > 0 && <span className="opacity-40">/</span>}
          <button
            type="button"
            onClick={() => setLanguage(opt)}
            aria-pressed={language === opt}
            className={`transition-colors duration-200 ease-engineered hover:text-accent ${
              language === opt ? (solid ? "text-ink" : "text-white") : ""
            }`}
          >
            {opt.toUpperCase()}
          </button>
        </span>
      ))}
    </div>
  );
}
